import styled from "styled-components/macro";

export const Container = styled.section`
  background: transparent;
  transition: margin-top 300ms ease-in-out;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  margin-left: 2em;
  margin-right: 2em;
  margin-top: 0.8em;

  img {
    max-height: ${({ small }) => (small ? "18px" : "28px")};
    width: auto;
    margin: ${({ small }) => (small ? "4px 0px" : "10px 0px")};
    mix-blend-mode: multiply;
    opacity: 0.45;
  }
  .logos {
    display: flex;
    gap: ${({ small }) => (small ? "1vw" : "2vw")};
    row-gap: ${({ small }) => (small ? "0" : "2vw")};
    transition: gap 300ms ease-in-out;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }
  .as-seen-in {
    font-family: Inter;
    font-size: 7px;
    font-weight: 700;
    line-height: 8px;
    letter-spacing: 0.5vw;
    margin-right: -0.5vw; //cancels out last-letter letterspacing
    padding-left: 0.5vw;
    padding-right: 0.5vw;
    text-align: center;
    color: #000;
    opacity: 0.45;
  }
  .content-row {
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    align-content: center;
    /* max-width: 900px; */
    margin: auto;
    width: 100vw;
  }
`;
